import { render, staticRenderFns } from "./MoveableModal.vue?vue&type=template&id=8324989c&scoped=true&"
import script from "./MoveableModal.vue?vue&type=script&lang=js&"
export * from "./MoveableModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8324989c",
  null
  
)

export default component.exports